import React from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
import { CheckCircle2 } from 'lucide-react';
export function IncludesSection() {
  const items = ['PDF completo con el protocolo de 14 noches', 'Checklist “Preparación 30/10/3”', 'Tarjeta imprimible “Reset 12 minutos” (mesa de noche)', 'Tarjeta “Plan 5/15/30/60”', 'Tracker 14 noches (para ver patrones reales)', 'Lista de compras por presupuesto ($0 / $25 / $75)'];
  return <section className="py-24 px-4" data-id="element-74">
      <div className="max-w-3xl mx-auto" data-id="element-75">
        <div className="bg-[var(--bg-card)] rounded-3xl p-8 md:p-12 border border-[var(--bg-card-hover)] shadow-2xl" data-id="element-76">
          <SectionWrapper data-id="element-77">
            <h2 className="text-3xl md:text-4xl text-[var(--text-primary)] mb-8 text-center" data-id="element-78">
              Qué incluye <br data-id="element-79" />
              <span className="text-xl text-[var(--text-secondary)] font-sans font-normal" data-id="element-80">
                (para que sepas exactamente lo que compras)
              </span>
            </h2>
          </SectionWrapper>

          <ul className="space-y-6" data-id="element-81">
            {items.map((item, index) => <SectionWrapper key={index} delay={0.1 + index * 0.08} data-id="element-82">
                <li className="flex items-start" data-id="element-83">
                  <CheckCircle2 className="w-6 h-6 text-[var(--green-soft)] mt-1 mr-4 shrink-0" data-id="element-84" />
                  <span className="text-lg md:text-xl text-[var(--text-primary)]" data-id="element-85">
                    {item}
                  </span>
                </li>
              </SectionWrapper>)}
          </ul>
        </div>
      </div>
    </section>;
}